import React from 'react';

import { socialIconsForCommon } from 'app/shared/utils/socialIcons';
import { artistSocialUrls } from 'app/shared/utils/socialLinks';
import { SocialUrlKey, SocialUrls } from 'app/shared/typings';
import { Box, BoxProps } from 'app/shared/components/atoms';
import { SocialIcons, SocialLink } from 'app/shared/components/molecules';

interface Props extends BoxProps {
  'data-qaid'?: string;
  socialUrls: SocialUrls;
}

const artistSocialUrlsToDisplay: SocialUrlKey[] = artistSocialUrls.filter(
  (socialUrlKey: SocialUrlKey) => socialUrlKey != 'urlSupport'
);

export const ArtistSocialIcons: React.FC<React.PropsWithChildren<Props>> = ({
  socialUrls,
  'data-qaid': qaId = '',
  children,
  ...boxProps
}) => {
  const socialUrlKeys: SocialUrlKey[] = artistSocialUrlsToDisplay.filter(
    (k) => !!socialUrls[k] && !!socialIconsForCommon[k]
  );

  if (socialUrlKeys.length == 0) {
    return null;
  }

  const socialLinks = socialUrlKeys.map((socialUrlKey) => ({
    icon: socialIconsForCommon[socialUrlKey],
    url: socialUrls[socialUrlKey],
    key: socialUrlKey,
    w:
      socialUrlKey === 'urlSoundcloud' || socialUrlKey === 'urlYoutube'
        ? 'auto'
        : undefined,
    fillColor: socialUrlKey === 'urlWebsite' ? 'none' : undefined,
  }));

  return (
    <Box {...boxProps}>
      <SocialIcons socialLinks={socialLinks as SocialLink[]} data-qaid={qaId}>
        {children}
      </SocialIcons>
    </Box>
  );
};
